import s from "./fifthStep.module.css";
import RatingSlider from "./RatingSlider";
import {useFifthStep} from "./useFifthStep";
import AdditionalComment from "./AdditionalComment";
import {fifthStepBackground, fourthStepBackground} from "../../../../assets";
import {useAppContext} from "../../../../contexts";

const FifthStep = (props) => {
    // Destructured props
    const {
        handleStepChange,
        handlePayloadUpdate,
        currentStep
    } = props;

    // Component logic data
    const componentProps = useFifthStep({
        handleStepChange,
        handlePayloadUpdate
    });

    // Destructured component logic data
    const {
        formValues,
        handleChange,
        handleSubmit
    } = componentProps;

    // Accessibility feature data
    const {highContrast} = useAppContext();

    return (
        <div className={`${s.root} ${currentStep !== 5 ? s.hideContent : ""}`}>
            <div className={`w-full flex flex-col-reverse md:flex-row items-start justify-between gap-y-12 gap-x-24`}>
                <div className={"flex flex-row justify-center w-full md:w-max shrink-0"}>
                    <img
                        src={fifthStepBackground}
                        alt="Background image"
                    />
                </div>
                <div>
                    <h1 className={`${s.heading} ${highContrast ? "!text-white" : ""}`}>
                        Em uma escala de 0 a 10, o quanto você recomendaria o Sabin para um amigo ou familiar?
                    </h1>
                    <form
                        onSubmit={e => handleSubmit(e)}
                        className={"w-full"}
                    >
                        <RatingSlider
                            formValues={formValues}
                            handleChange={handleChange}
                        />
                        <AdditionalComment
                            formValues={formValues}
                            handleChange={handleChange}
                        />
                    </form>
                </div>
            </div>
        </div>
    )
}

export default FifthStep;
